module.exports = {
  title: 'Circular Carousel with React Native Reanimated 🪄',
  author: 'Enzo Manuel Mangano',
  date: '2023-08-30',
  slug: 'circular-carousel',
  tags: ['reanimated'],
};
